import { render, staticRenderFns } from "./WatsAppReportByAgeny.vue?vue&type=template&id=74859a4d&"
import script from "./WatsAppReportByAgeny.vue?vue&type=script&lang=js&"
export * from "./WatsAppReportByAgeny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports